<template>
    <div class="tw-flex tw-flex-col">
        <h5 class="tw-text-lg tw-font-semibold tw-text-gray-700 tw-m-0 tw-mb-4">
            <slot name="title" />
        </h5>

        <div
            class="tw-flex-1 tw-flex tw-items-center tw-p-5 tw-rounded-2xl tw-overflow-hidden tw-border tw-border-solid tw-border-gray-200"
        >
            <div
                class="tw-flex tw-flex-grow-0 tw-items-center tw-justify-start tw-text-gray-800 tw-text-3xl"
            >
                <div
                    class="tw-p-2 tw-w-10 tw-h-10 tw-flex tw-items-center tw-justify-center tw-align-middle tw-bg-gray-50 tw-rounded-lg tw-mr-5 tw-text-indigo-500"
                >
                    <i class="fal tw-text-lg" :class="icon" />
                </div>
                <div class="tw-font-bold">
                    <slot name="number" />
                </div>
            </div>

            <div class="tw-flex-1 tw-flex tw-flex-wrap tw-ml-5">
                <div class="tw-flex-initial tw-text-sm tw-inline-block tw-pr-3">
                    <slot />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
            default: "",
        },
    },
};
</script>
